import React from "react";
import "./entry.scss";
import BaseMap from "./right/basemap";
import AreaLeftMenu from "./left-menu/area-leftmenu";
import ProvinceLeftMenu from "./left-menu/province-leftmenu";
import SpecialLeftMenu from "./left-menu/special-leftmenu";
import OpenlayersMapView from "../openlayers-map/openlayers-map.view";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as MapDataStore from "../../redux/store/map-data/map-data.store";
import { GeneralPlanningViewProps, GeneralPlanningViewState, } from "../../models/general-planning-view/props-state.model";
import {isMobile} from 'react-device-detect';
import {ListBaseMap} from "../../api/api-service";

class Entry extends React.Component<GeneralPlanningViewProps, GeneralPlanningViewState> {
  constructor(props: GeneralPlanningViewProps) {
    super(props);
    this.state = {
      categoryId:this.props.match.params?.categoryId,
      isLeftNavbarHide: false,
      modalHeightStyle: 0,
      isShowMapToolsPanel: false,
      isShowFilterInfomationPopup: false,
      isDisplaySearchResult: false,
      displaySearchLocationBar: false,
      coordinate: "",
    };
    this.openFilterInfomationPopup = this.openFilterInfomationPopup.bind(this);
    this.closeFilterInfomationPopup = this.closeFilterInfomationPopup.bind(this);
  }

  componentDidMount() {
    this.setState({
      modalHeightStyle: window.innerHeight - 100,
    });
    if(this.state.categoryId == "5" || this.state.categoryId == "42" || this.state.categoryId == "43"){
      this.props.GetAllPlanningBoundaries(this.state.categoryId);
    }
    if(isMobile){
      this.handleShowHidePlanningMenu();
    }
  }

  handleClickIconLeftNavbar(id: number) {
    this.handleClickToggleLeftNavBar();
    const buttonElement = document.querySelector(
      `button[aria-controls="${id}"]`
    ) as HTMLElement;
    if (buttonElement?.classList.contains("collapsed")) buttonElement.click();
  }

  handleClickToggleLeftNavBar() {
    this.setState({
      isLeftNavbarHide: !this.state.isLeftNavbarHide,
    });
    if (!this.state.isLeftNavbarHide) {
      document
        .getElementsByClassName("left-custom-navbar")[0]
        .classList.add("hide-left-navbar");
    } else
      document
        .getElementsByClassName("left-custom-navbar")[0]
        .classList.remove("hide-left-navbar");
  }

  openFilterInfomationPopup() {
    this.setState({
      isShowFilterInfomationPopup: true,
    });
  }

  closeFilterInfomationPopup() {
    this.setState({
      isShowFilterInfomationPopup: false,
    });
  }

  manualCloseMaptoolsFilterInfomationPopup = () => {
    this.setState({ isShowFilterInfomationPopup: false });
  };

  handleOpenOrCloseMapToolsPanel = () => {
    this.setState({
      isShowMapToolsPanel: !this.state.isShowMapToolsPanel,
    });
  };

  handleShowHidePlanningMenu() {
    const LeftMenuElement = document.getElementsByClassName(
      "left-custom-navbar"
    )[0] as HTMLElement;
    if (LeftMenuElement) {
      if (this.state.isLeftNavbarHide) {
        LeftMenuElement.style.left = "0";
      } else {
        LeftMenuElement.style.left = "-320px";
      }
      this.setState({ isLeftNavbarHide: !this.state.isLeftNavbarHide });
    }
  }

  render() {
    const isLeftNavbarHide = this.state.isLeftNavbarHide;
    let LeftMenu;
    if(this.state.categoryId == "5"){
      LeftMenu = <AreaLeftMenu
          resetSearchDisplayMode={() => this.setState({ isDisplaySearchResult: false })}
          isDisplaySearchResult={this.state.isDisplaySearchResult}
      />
    }else if (this.state.categoryId == "42"){
      LeftMenu = <ProvinceLeftMenu
          resetSearchDisplayMode={() => this.setState({ isDisplaySearchResult: false })}
          isDisplaySearchResult={this.state.isDisplaySearchResult}
      />
    }else if (this.state.categoryId == "43"){
      LeftMenu = <SpecialLeftMenu
          resetSearchDisplayMode={() => this.setState({ isDisplaySearchResult: false })}
          isDisplaySearchResult={this.state.isDisplaySearchResult}
      />
    }

    return (
      <div className="general-planning-map-view-container position-relative">
        {/* Top right panel*/}
        <BaseMap
          isHiddenMapTools={true}
          baseMapList={ListBaseMap}
          isHiddenSearch={true}
          isHiddenLayer={true}
          isHiddenInfor={true}
        />

        {/* Open layer view port */}
        <OpenlayersMapView
            baseMapType = "google"
            projection={"EPSG:4326"}
            isGeneralPlanning={true}
            coordinate={this.props.location}
            extent={[78.757192,-6.768174,119.186877,33.491089]}
            defaultCenter={[108.644204,15.040511]}
            defaultZoom={1}
        />

        {/* Left nav bar */}
        {(this.state.categoryId == "5" || this.state.categoryId == "42" || this.state.categoryId == "43") && (
            <div className="left-custom-navbar position-absolute h-100">
              <button
                  onClick={() => this.handleShowHidePlanningMenu()}
                  className="custom-button-left-menu btn position-absolute"
                  title="Các lớp quy hoạch"
              >
                <img
                    src={require(isLeftNavbarHide
                        ? "../../assets/icon/layer.svg"
                        : "../../assets/icon/closeX.svg")}
                    alt="Close"
                />
              </button>
              {LeftMenu}
            </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  hasLoadedMapData: state.mapData.hasLoadingData,
});

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      GetAllPlanningBoundaries: MapDataStore.GetAllPlanningBoundaries,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Entry);
